module.exports = __webpack_public_path__ + "static/amelie-lens-d2d2cacd89385a06141fb2c60759e483.jpg";